import {combineReducers} from 'redux';
// @ts-expect-error
import {createReducer} from 'redux-act';

import type {ReportRowData, TimeseriesReportData, ListItem} from 'nutshell-core/types';

import * as actions from './audiences-actions';

type AudienceMemberListState = {
    isLoading: boolean;
    isFirstLoad: boolean;
    errorMessage?: string;
    listItems: any[];
    meta: any;
};

const audienceMemberListDefaultState = {
    isLoading: true,
    isFirstLoad: true,
    errorMessage: undefined,
    listItems: [],
    meta: {},
} as const;

const isFilterDrawerOpen = createReducer(
    {
        // @ts-expect-error
        [actions.toggleShowFilterDrawer]: (state) => !state,
    },
    false
);

export const audienceMemberListReducer = createReducer(
    {
        // @ts-expect-error
        [actions.requestAudienceMemberListData]: (state) => {
            return {...state, isLoading: true, errorMessage: undefined};
        },
        // @ts-expect-error
        [actions.updateAudienceMemberListData]: (state, {meta, listItems}) => {
            return {
                ...state,
                isLoading: false,
                isFirstLoad: false,
                meta: meta,
                listItems: listItems
                    ? listItems.map((item: ListItem) => {
                          return {
                              ...item,
                              id: item.links ? item.links.entity.id : item.id,
                          };
                      })
                    : undefined,
                errorMessage: undefined,
            };
        },
        // @ts-expect-error
        [actions.failAudienceMemberListData]: (state, err) => {
            return {...state, isLoading: false, isFirstLoad: false, errorMessage: err};
        },
    },
    audienceMemberListDefaultState
);

type AudienceMembershipReportTableData = {
    rows: ReportRowData[] | null | undefined;
    totals: ReportRowData | null | undefined;
};
type AudienceMembershipReportState = {
    timeseriesChart: {
        isLoading: boolean;
        isTimedOut: boolean;
        isErrored: boolean;
        chartData: TimeseriesReportData | null | undefined;
        prefix: string;
    };
};
const audienceMembershipReportDefaultState = {
    timeseriesChart: {
        isLoading: true,
        isTimedOut: false,
        isErrored: false,
        chartData: null,
        prefix: '$',
    },
} as const;

const audienceMembershipReportReducer = createReducer(
    {
        [actions.updateAudienceMembershipReportTableData]: (
            // @ts-expect-error
            state,
            payload: AudienceMembershipReportTableData
        ) => {
            return {...state, tableData: payload};
        },
        // @ts-expect-error
        [actions.requestAudienceMembershipReportData]: (state) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: true,
                isTimedOut: false,
                isErrored: false,
            } as const;

            return {...state, timeseriesChart: newChartState};
        },
        // @ts-expect-error
        [actions.updateAudienceMembershipReportChartData]: (state, {chartData}) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: false,
                isTimedOut: false,
                isErrored: false,
                chartData,
            } as const;

            return {...state, timeseriesChart: newChartState};
        },
        // @ts-expect-error
        [actions.failAudienceMembershipReportChartData]: (state, err) => {
            if (err) {
                if (err.status === 504 || err.status === 502) {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: true,
                        isErrored: false,
                    } as const;

                    return {...state, timeseriesChart: newChartState};
                } else {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: false,
                        isErrored: true,
                    } as const;

                    return {...state, timeseriesChart: newChartState};
                }
            }

            return state;
        },
    },
    audienceMembershipReportDefaultState
);

export const audiencesReducer = combineReducers({
    audienceMemberList: audienceMemberListReducer,
    audienceMembershipReport: audienceMembershipReportReducer,
    isFilterDrawerOpen,
});

export type AudiencesState = {
    audienceMemberList: AudienceMemberListState;
    audienceMembershipReport: AudienceMembershipReportState;
    isFilterDrawerOpen: boolean;
};
